<template>
  <el-tag v-if="text" type="info" :hit="true" size="small">
    {{ text }}
  </el-tag>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { DspAdTypeLabels, AdTypeLabel } from '@/api/types'
export default defineComponent({
  name: 'AdTypeLabel',
  props: {
    type: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const text = computed(() => {
      const label = DspAdTypeLabels.find(
        (x: AdTypeLabel) => x.type_id === props.type
      )
      return label ? label.label : null
    })
    return { text }
  }
})
</script>
<style lang="scss" scoped>
.el-tag {
  margin-left: 5px;
  border: none !important;
}
</style>
